<template>
  <div class="contact-container fade-in-section">
    <ContactForm />
  </div>
</template>

<script>
import ContactForm from "@/components/ContactForm.vue";

export default {
  name: "Contact",
  components: { ContactForm },
  mounted() {
    this.observeSection();
  },
  methods: {
    observeSection() {
      const section = document.querySelector('.fade-in-section');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      observer.observe(section);
    }
  }
};
</script>

<style scoped>
/* Fade-in animation for the contact container */
.fade-in-section {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease-out, transform 1s ease-out;
}

/* When element becomes active (in view) */
.fade-in-section.active {
  opacity: 1;
  transform: translateY(0);
}

/* Import the custom font */
@font-face {
  font-family: "WixMadeforText";
  src: url("@/assets/WixMadeforText-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.contact-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: "WixMadeforText", sans-serif;
}

h1 {
  text-align: center;
  color: #333;
  font-size: 28px;
  margin-bottom: 20px;
}

p {
  text-align: center;
  color: #555;
  font-size: 16px;
  margin-bottom: 30px;
}

.contact-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 20px;
}

label {
  font-size: 16px;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

input,
textarea {
  width: 100%;
  padding: 12px;
  font-size: 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

textarea {
  height: 150px;
  resize: vertical;
}

button.submit-btn {
  background-color: #00bcd4;
  color: white;
  font-size: 18px;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

button.submit-btn:hover {
  background-color: #0097a7;
}

/* Responsive Styles */
@media screen and (max-width: 768px) {
  .contact-container {
    padding: 15px;
  }

  h1 {
    font-size: 24px;
  }

  p {
    font-size: 14px;
  }

  button.submit-btn {
    font-size: 16px;
    padding: 10px 15px;
  }
}
</style>
